module.exports = __webpack_public_path__ + "img/icon-fish-pink.234ed73e.svg";